import { createApp } from 'vue'
import vSelect from 'vue-select' // https://vue-select.org
import 'vue-select/dist/vue-select.css'
import VueSocialSharing from 'vue-social-sharing'
import PlaceholderTopics from './Components/PlaceholderTopics'
import TopicsRiver from './Components/TopicsRiver'
import Soundbite from './Components/Soundbite'
import CustomSelect from './Components/CustomSelect'
import SearchSection from './Components/SearchSection'

const app = createApp({
  data: () => ({
    searchOpen: false,
    navOpen: false
  }),
  components: {
    'placeholder-topics': PlaceholderTopics,
    'topics-river': TopicsRiver,
    'soundbite': Soundbite,
    'custom-select': CustomSelect,
    'v-select': vSelect,
    'search-section': SearchSection
  },
  mounted() {
    document.addEventListener('keyup', (e) => {
      if (e.key == "Escape") {
        if (this.searchOpen) {
          this.toggleSearch()
        }
        if (this.navOpen) {
          this.toggleNav()
        }
      }
    })
    document.addEventListener('click', (e) => {
      if (this.searchOpen && !e.target.closest('header')) {
        this.toggleSearch()
      }
      if (this.navOpen && (!e.target.closest('#primary-nav', 'header'))) {
        this.toggleNav()
      }
      if (e.target == document.querySelector('#primary-nav__close')) {
        this.toggleNav()
      }
    })
  },
  methods: {
    toggleSearch() {
      if (!this.searchOpen) {
        document.querySelector('#header-search').removeAttribute('hidden')
        setTimeout(() => {
          document.querySelector('body').classList.add('search-open')
          document.querySelector('#header-search__input').focus()
        }, 10)
      } else {
        document.querySelector('body').classList.remove('search-open')
        document.querySelector('[aria-controls="header-search"]').focus()
        setTimeout(() => {
          document.querySelector('#header-search').setAttribute('hidden', true)
        }, 300)
      }
      this.searchOpen = !this.searchOpen
    },
    toggleNav() {
      if (!this.navOpen) {
        if (this.searchOpen) {
          this.toggleSearch()
        }
        document.querySelector('#primary-nav').removeAttribute('hidden')
        setTimeout(() => {
          document.querySelector('body').classList.add('nav-open')
          document.querySelector('#primary-nav__close').focus()
          this.navOpen = true
        }, 10)
      } else {
        document.querySelector('body').classList.remove('nav-open')
        document.querySelector('[aria-controls="primary-nav"]').focus()
        setTimeout(() => {
          document.querySelector('#primary-nav').setAttribute('hidden', true)
          this.navOpen = false
        }, 300)
      }
    }
  }
}).use(VueSocialSharing)

app.mount('#app')
